import Vue from 'vue'
import { useRoute } from 'vue-router/composables'

import { AGiftOrder } from 'kuaidong-api'

const activityLotteryAddressSkusKeyPrefix = 'activity_lottery_address_skus'

export interface IActivityLotteryAddressSku {
  id: string
  banner_img?: string
  img_url?: string
  current_stock?: number
}

export function getActivityLotteryAddressSkusStorageKey(_activityId: string) {
  return `${activityLotteryAddressSkusKeyPrefix}:${_activityId}`
}

export function setActivityLotteryAddressSkus(_activityId: string, _skus: unknown[]) {
  sessionStorage.setItem(getActivityLotteryAddressSkusStorageKey(_activityId), JSON.stringify(_skus))
}

export function consumeActivityLotteryAddressSkus<T>(_activityId: string): T[] | null {
  const _key = getActivityLotteryAddressSkusStorageKey(_activityId)
  const _raw = sessionStorage.getItem(_key)
  if (!_raw) {
    return null
  }
  sessionStorage.removeItem(_key)
  try {
    return JSON.parse(_raw) as T[]
  } catch {
    return null
  }
}

export function useGiftAddressPageJumper() {
  const route = useRoute()

  async function jump2GiftAddressConfirm<
    T extends {
      banner_img: string
      img_url: string
    }
  >(gift: T, nextPathQuery: Record<string, any>) {
    let addressId: string | null = null // 默认为空说明新建
    const address = await AGiftOrder.getCandidateTeacherAddress()
    if (address) {
      addressId = address.address_id // 有id则传入进行编辑或者确认
    }

    Vue.routerHelper.navigateToGiftAddressConfirm(addressId, {
      bannerUrl: gift.banner_img || gift.img_url || '',
      nextPath: route.path,
      nextPathQuery,
    })
  }

  async function jump2LotteryGiftAddressConfirm(
    _activityId: string,
    _skus: IActivityLotteryAddressSku[],
    _nextPathQuery: Record<string, any>,
    _prizeGroupName?: string
  ) {
    if (!_skus.length) {
      throw new Error('no_skus')
    }
    const _bannerSku = _skus[0]
    setActivityLotteryAddressSkus(_activityId, _skus)

    let addressId: string | null = null
    const address = await AGiftOrder.getCandidateTeacherAddress()
    if (address) {
      addressId = address.address_id
    }

    Vue.routerHelper.navigateToGiftAddressConfirm(addressId, {
      bannerUrl: _bannerSku.banner_img || _bannerSku.img_url || '',
      nextPath: route.path,
      nextPathQuery: _nextPathQuery,
      lotteryActivityId: _activityId,
      prizeGroupName: _prizeGroupName || '',
    })
  }

  return {
    jump2GiftAddressConfirm,
    jump2LotteryGiftAddressConfirm,
  }
}
